import React from "react";
import { SearchBar } from "@src/components/organisms/searchbar-component/searchbar-component";
import { transformedGatewaysWithMachinesListEntryTypes } from "@common/types/machines-list-types";
import { findSearchedMachinesList } from "./machines-list-search";

type MachineListByCompany = Record<
  string,
  transformedGatewaysWithMachinesListEntryTypes
>;

const EMPTY_SEARCH_RESULT: MachineListByCompany = {};

interface MachinesListSearchBarPropsTypes {
  allMachinesListData: MachineListByCompany;
  machinesManagerSearchTerms: string[];
  machinesManagerSearchQuery: string;
  onSearchTermsChange: (machinesManagerSearchTerms: string[]) => void;
  onSearchQueryChange: (machinesManagerSearchQuery: string) => void;
  onSearchResults: (result: MachineListByCompany) => void;
}

export const MachinesListSearchBar = ({
  allMachinesListData,
  machinesManagerSearchTerms,
  machinesManagerSearchQuery,
  onSearchTermsChange,
  onSearchQueryChange,
  onSearchResults,
}: MachinesListSearchBarPropsTypes) => (
  <SearchBar
    data={allMachinesListData}
    searchFn={findSearchedMachinesList}
    emptyResult={EMPTY_SEARCH_RESULT}
    searchTerms={machinesManagerSearchTerms}
    searchQuery={machinesManagerSearchQuery}
    onSearchTermsChange={onSearchTermsChange}
    onSearchQueryChange={onSearchQueryChange}
    onSearchResults={onSearchResults}
  />
);
